function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5625 16.625C3.5625 16.1526 3.75017 15.6995 4.08422 15.3655C4.41827 15.0314 4.87133 14.8438 5.34375 14.8438H15.4375V2.375H5.34375C4.87133 2.375 4.41827 2.56267 4.08422 2.89672C3.75017 3.23077 3.5625 3.68383 3.5625 4.15625V16.625Z",
  strokeWidth: 1.1875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5625 16.625V17.2188H14.25",
  strokeWidth: 1.1875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgGlossary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlossary);
export default __webpack_public_path__ + "static/media/Glossary.e2314f194701d86153ae2939e6fc67d3.svg";
export { ForwardRef as ReactComponent };